/**
 * A table as CSV text, built in the browser.
 *
 * Only for when there is no server to lay the file out (offline, or before
 * the export route exists); the server's file is the normal one. The rows
 * are what the grid is showing - filtered, sorted, visible columns in their
 * order - already reduced to plain values by the column's exportValue.
 *
 * RFC 4180: comma-separated, CRLF between records, every field quoted and
 * any quote inside it doubled, which is the one form every spreadsheet reads
 * the same way. A byte-order mark goes first, or Excel reads the file as
 * Windows-1252 and "Dubaï" comes out as mojibake.
 *
 * Pure, so it can be run in Node.
 */

/*
 * A spreadsheet treats a cell that starts with one of these as a formula,
 * and a formula in a file somebody opens can run a command or send data
 * off. Lead names, notes and landing pages are typed by strangers on a web
 * form, so any text that starts that way gets a leading apostrophe, which
 * makes the spreadsheet show it as the text it is. Numbers are left alone:
 * a real -5 is not an attack.
 */
const FORMULA_START = /^[=+\-@\t\r]/;

/** One field, quoted and made safe to open. */
export function csvField(value) {
  if (value === undefined || value === null) return '""';
  let text = String(value);
  if (typeof value !== 'number' && FORMULA_START.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

/**
 * The whole file. `columns` is [{ key, label }], `rows` is [{ [key]: value }]
 * - the same shape the server export takes.
 */
export function toCSV(columns, rows) {
  const lines = [columns.map(c => csvField(c.label)).join(',')];
  rows.forEach(r => lines.push(columns.map(c => csvField(r[c.key])).join(',')));
  return `\uFEFF${lines.join('\r\n')}\r\n`;
}
